export default __webpack_public_path__ + "static/media/icon-circle.718b560a.svg";